module.exports = __webpack_public_path__ + "img/1582879917.543f279a.jpg";